import * as React from 'react';
import { Link } from 'react-router-dom';
import { Link as ExternalLink } from 'ui';
import { MdMailOutline as MdMessage, MdHelp, MdFeedback } from 'react-icons/md';
import { FaSignOutAlt as FaSignOut } from 'react-icons/fa';
import { routeConstants } from 'app/routes/route-constants';
import { isValidUrl } from 'app/infrastructure/validation/url';
import { logout } from 'app/shell/logout';
import { When } from './when';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  helpUrl: string;
  feedbackUrl: string;
  onItemClick: () => void;
}

export const FooterMenuItems = ({ translation, helpUrl, feedbackUrl, onItemClick }: Props) => (
  <>
    <When condition={isValidUrl(helpUrl)}>
      <li onClick={onItemClick}>
        <ExternalLink url={helpUrl} className={'list-group-item'}>
          <MdHelp className={styles.navItemIcon} />
          <span className={`${styles.navItemText} ${styles.small}`}>
            {translation.help}
          </span>
        </ExternalLink>
      </li>
    </When>

    <li onClick={onItemClick}>
      <Link to={routeConstants.messagesToUserView} className="list-group-item">
        <MdMessage className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.messages}
        </span>
      </Link>
    </li>

    <When condition={isValidUrl(feedbackUrl)}>
      <li onClick={onItemClick}>
        <ExternalLink url={feedbackUrl} className={'list-group-item'}>
          <MdFeedback className={styles.navItemIcon} />
          <span className={`${styles.navItemText} ${styles.small}`}>
            {translation.feedback}
          </span>
        </ExternalLink>
      </li>
    </When>

    <li>
      <button type="button" id="nav-logout-button" className="list-group-item" onClick={logout}>
        <FaSignOut className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.logout}</span>
      </button>
    </li>
  </>
);
